import { API_ROUTES } from '@/constants/apiRoutes';
import type { AxiosInstance } from 'axios';
import { ChargeStatus } from './charges.types';

export interface CreateChargePayload {
  agentType: string;
  categoryName: string;
  description: string;
  chargeCategoryId?: string;
}

export interface AssignChargePayload {
  chargeCategoryId: string;
  agentId: string;
  agentType: string;
}

export interface ToggleStatusPayload {
  agentType: string;
  chargeCategoryId: string;
  status: 'A' | 'B';
}

export interface UpdateChargeSubcategoryPayload {
  chargeSubCategoryId?: string;
  chargeCategoryId?: string;
  agentType?: string;
  categoryType?: string;
  description?: string;
}

export interface ToggleStatusSubcategoryPayload {
  chargeCategoryId: string;
  status: 'A' | 'B' | 'D';
  chargeSubCategoryId: string;
  agentType?: string;
}

const assignCharge = (client: AxiosInstance) => async (payload: AssignChargePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.ASSIGN_CHARGE, payload)).data;
};

const createCharge = (client: AxiosInstance) => async (payload: CreateChargePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.MANAGE_CHARGE, payload)).data;
};

const toggleStatusCharge = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (await client.post<{ message: string; data: ChargeStatus }>(API_ROUTES.CHARGE_STATUS, payload)).data;
};

const addSubcategory = (client: AxiosInstance) => async (payload: UpdateChargeSubcategoryPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.ADD_CHARGE_SUBCATEGORY, payload)).data;
};

const updateSubcategory = (client: AxiosInstance) => async (payload: UpdateChargeSubcategoryPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_CHARGE_SUBCATEGORY, payload)).data;
};

const toggleSubcategoryStatus = (client: AxiosInstance) => async (payload: ToggleStatusSubcategoryPayload) => {
  return (
    await client.post<{ message: string; data: ChargeStatus }>(API_ROUTES.UPDATE_CHARGE_SUBCATEGORY_STATUS, payload)
  ).data;
};

export const chargeMutations = {
  assignCharge,
  createCharge,
  toggleStatusCharge,
  addSubcategory,
  updateSubcategory,
  toggleSubcategoryStatus,
};
